function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZaralittle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.01 31.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    style: {
      fill: "#f5f3f1",
      strokeWidth: 0
    },
    d: "M71.43,30.36L59.95.06l-.02-.06h-.17l-6.35,17.5c-1.44-1.27-3.47-2.07-6.03-2.36l-.78-.08.77-.1c4.22-.76,7.06-3.43,7.06-6.63,0-4.4-4.14-7.48-10.07-7.48h-12.5v.22h3.59v22.37L26.54.02h-.17l-10.99,30.29h-.05c-.38.05-.74.08-1.11.08H5.37L22.7.85H1.68v9.06h.22c.04-4.41,2.61-8.84,8.29-8.84h7.19L0,30.61h22.96v-8.68h-.22c-.03,3.85-2.21,7.5-6.95,8.32l-.15.03,3.61-9.93h10.13l3.6,10.01h-3.53v.22h14.27v-.22h-3.61v-15.14h4.17c4.24,0,6.67,1.9,6.67,5.2v2.69c0,.3.02.73.04,1.09h0s-2.24,6.17-2.24,6.17h-2.93v.22h6.06v-.22h-2.9l2.04-5.6v.09s.06.51.06.51l.05.33c.34,2.07,1.13,3.59,2.35,4.52l.18.13c.92.65,2.07.97,3.42.97,1.78,0,2.97-.44,3.95-1.49l-.13-.13c-.9.83-1.66,1.17-2.61,1.17-1.62,0-2.46-1.96-2.46-3.9v-3.76c0-.99-.14-1.91-.43-2.75l-.04-.12h7.41l3.61,10.03h-3.57v.22h12.22v-.22h-3.57ZM19.31,20.13l4.98-13.71,4.98,13.71h-9.96ZM40.1,15V1.07h3.18c4.25,0,6.49,2.53,6.49,7.3,0,5.08-1.29,6.63-5.51,6.63h-4.17ZM55.26,20.1l-.02-.05c-.33-.81-.81-1.53-1.41-2.16l-.21-.21-.04-.03,4.09-11.27,4.98,13.71h-7.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZaralittle);
export default __webpack_public_path__ + "static/media/ZARALITTLE.b7bbb3fdfd78a0372d7ca9952e3212af.svg";
export { ForwardRef as ReactComponent };